import { cloneElement, FC, ReactElement } from 'react'
import type { ButtonProps } from './Button'

interface Props {
  children?: ReactElement<ButtonProps>[]
}

export const ButtonGroup: FC<Props> = ({ children }) => {
  return (
    <span className="-space-x-px relative z-0 inline-flex shadow-sm rounded-md">
      {children?.map((child, index) => {
        let roundedClass = ''
        const roundedSize = child.size ?? 'lg'

        if (index === 0) {
          roundedClass = `rounded-l-${roundedSize}`
        } else if (index === children.length - 1) {
          roundedClass = `rounded-r-${roundedSize}`
        }

        return cloneElement(child, {
          className: `${child.className ?? ''} ${roundedClass}`.trim(),
          noRounding: true,
        })
      })}
    </span>
  )
}
